import { useState, type FormEvent } from 'react';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9pi1cdi2vhsdh2d3510';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });

      const responseText = await response.text();
      let serverMsg = '';
      try {
        const parsed = JSON.parse(responseText);
        serverMsg = parsed?.meta?.message || parsed?.message || '';
      } catch {
        serverMsg = '';
      }

      if (response.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，最新吃瓜资讯将第一时间发送到您的邮箱。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      data-readdy-form
      className="flex flex-col sm:flex-row gap-3"
    >
      <div className="flex-1 relative">
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="输入您的邮箱地址"
          required
          className="w-full px-4 py-3 text-sm rounded-lg border border-background-300 bg-white text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
        />
      </div>
      <div className="honeypot-wrapper">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>
      <button
        type="submit"
        disabled={status === 'loading'}
        className="px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap disabled:opacity-60 cursor-pointer"
      >
        {status === 'loading' ? (
          <span className="flex items-center gap-2">
            <i className="ri-loader-4-line animate-spin w-4 h-4 flex items-center justify-center"></i>
            订阅中
          </span>
        ) : (
          '立即订阅'
        )}
      </button>
      {status !== 'idle' && (
        <div className={`sm:col-span-2 text-sm mt-1 ${status === 'success' ? 'text-accent-600' : 'text-primary-600'}`}>
          {message}
        </div>
      )}
    </form>
  );
}